import "./styles.css";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import useLangStore from "@/hooks/useLangStore";

const LANG_CARDS = [
    { lang: "ar" as const, label: "العربية", flag: "/images/arabic-lang.png" },
    { lang: "en" as const, label: "English", flag: "/images/english-lang.png" },
];

export default function ChooseLangScreen() {
    const { setLang } = useLangStore();
    const navigate = useNavigate();
    const [selected, setSelected] = useState<"ar" | "en" | null>(null);

    const handleContinue = () => {
        if (!selected) return;
        setLang(selected);
        navigate("/login");
    };

    return (
        <div className="choose-lang-screen">
            <div className="choose-lang-content">
                <img src="/icons/choose-lang-icon.svg" className="choose-lang-icon" alt="" />
                <div className="choose-lang-header">
                    <p className="choose-lang-title">اختر لغتك</p>
                    <p className="choose-lang-subtitle">Choose your language</p>
                </div>
                <div className="choose-lang-cards">
                    {LANG_CARDS.map(({ lang, label, flag }) => (
                        <button
                            key={lang}
                            className={`choose-lang-card${selected === lang ? " choose-lang-card--selected" : ""}`}
                            onClick={() => setSelected(lang)}
                        >
                            <img src={flag} className="choose-lang-card-flag" alt={label} />
                            <p className="choose-lang-card-label">{label}</p>
                        </button>
                    ))}
                </div>
                <button className="choose-lang-continue-btn" onClick={handleContinue} disabled={!selected}>
                    {selected === "en" ? "Continue" : "متابعة"}
                    <img src="/icons/arrow-dark-icon.svg" className="choose-lang-continue-arrow" alt="" />
                </button>
            </div>
        </div>
    );
}
